// src/services/expensesService.ts
import { api } from "./api";
import {
  HandlersExpenseResponse,
  HandlersExpenseCreate,
  HandlersExpenseUpdate,
  HandlersExpenseShareResponse,
  HandlersExpenseShareUpdate,
} from "../generated";

export const expensesService = {
  // Get all expenses for the authenticated user
  getAllExpenses: async (): Promise<HandlersExpenseResponse[]> => {
    const response = await api.get<HandlersExpenseResponse[]>("/expenses");
    return response.data;
  },

  // Get a specific expense by ID
  getExpense: async (expenseId: string): Promise<HandlersExpenseResponse> => {
    const response = await api.get<HandlersExpenseResponse>(
      `/expenses/${expenseId}`
    );
    return response.data;
  },

  // Create a new expense
  createExpense: async (
    expenseData: HandlersExpenseCreate
  ): Promise<HandlersExpenseResponse> => {
    const response = await api.post<HandlersExpenseResponse>(
      "/expenses",
      expenseData
    );
    return response.data;
  },

  // Update an existing expense
  updateExpense: async (
    expenseId: string,
    expenseData: HandlersExpenseUpdate
  ): Promise<HandlersExpenseResponse> => {
    const response = await api.put<HandlersExpenseResponse>(
      `/expenses/${expenseId}`,
      expenseData
    );
    return response.data;
  },

  // Delete an expense
  deleteExpense: async (expenseId: string): Promise<void> => {
    await api.delete(`/expenses/${expenseId}`);
  },

  // Get all expenses for a group
  getGroupExpenses: async (
    groupId: string
  ): Promise<HandlersExpenseResponse[]> => {
    const response = await api.get<HandlersExpenseResponse[]>(
      `/groups/${groupId}/expenses`
    );
    return response.data;
  },

  // Get all shares for an expense
  getExpenseShares: async (
    expenseId: string
  ): Promise<HandlersExpenseShareResponse[]> => {
    const response = await api.get<HandlersExpenseShareResponse[]>(
      `/expenses/${expenseId}/shares`
    );
    return response.data;
  },

  // Update a share's paid status
  updateExpenseShare: async (
    expenseId: string,
    shareId: string,
    shareData: HandlersExpenseShareUpdate
  ): Promise<HandlersExpenseShareResponse> => {
    const response = await api.put<HandlersExpenseShareResponse>(
      `/expenses/${expenseId}/shares/${shareId}`,
      shareData
    );
    return response.data;
  },
};

export default expensesService;
